import { FormControl, InputLabel, MenuItem } from "@mui/material";
import { Field } from "formik";
import { Select } from "formik-mui";
import React, { ReactElement } from "react";

import { FieldDataItem, FieldProps } from "./Field";

export interface DropdownFieldProps extends FieldProps {
	data: FieldDataItem[];
	defaultText?: string;
	renderItem?: (item: FieldDataItem) => ReactElement | string | null;
	defaultValue?: string;
}

const DropdownField = ({
	className,
	name,
	label,
	id,
	helpText,
	data,
	defaultText,
	fullWidth = true,
	size = "small",
	renderItem,
	required,
	disabled,
	defaultValue = "",
	...others
}: DropdownFieldProps) => {
	const realId = id || name;

	const renderMenuItem = (item: FieldDataItem) => {
		if (renderItem) {
			return renderItem(item);
		}
		return item.label || item.value;
	};

	return (
		<FormControl
			fullWidth={fullWidth}
			variant="standard"
			className={className}
			required={required}
			disabled={disabled}
		>
			{label && (
				<InputLabel
					style={{ position: "unset", transform: "none" }}
					disableAnimation
					htmlFor={realId}
					className="mb-1 text-sm font-semibold"
				>
					{label}
				</InputLabel>
			)}
			<Field
				component={Select}
				formHelperText={helpText && { children: helpText }}
				id={realId}
				name={name}
				labelId={`${realId}-label`}
				displayEmpty={!!defaultText}
				size={size}
				classes={{ select: "h-6 pt-1 pb-3" }}
				disabled={disabled}
				{...others}
			>
				{defaultText && (
					<MenuItem value={defaultValue}>
						<span className="text-gray-600">{defaultText}</span>
					</MenuItem>
				)}
				{data.map((item) => (
					<MenuItem key={`${item.value}`} value={item.value}>
						{renderMenuItem(item)}
					</MenuItem>
				))}
			</Field>
		</FormControl>
	);
};

export { DropdownField };
